import React, { useContext, useEffect, useRef, useState } from 'react';
import { LangContext } from '../../contexts/langContext';
import { SocialContext } from '../../contexts/socialContext';
import { StateContext } from '../../contexts/stateContext';
import { QR } from '../UiKit/QR';
import { Button } from './Button';
import { PentaName, PentaNameText } from '../Penta/PentaName';
import { Icon } from './Icon';
import { APP_URL as URL } from '../../apiUrl';



export const PentaShare = React.memo(({ penta = {}, handleClose }) => {

  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) };
  const $ui = context.$ui;
  const [copydone, setCopydone] = useState(false);
  const [name, setName] = useState(penta.name);
  const inputRef = useRef(null);
  const inputName = useRef(null);

  const getPentaUrl = () => `${URL}/p/${penta.token}#ln=${context.language}`

  const handleCopy = () => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(getPentaUrl())
        .then(() => {
          console.log("Text copied to clipboard successfully!");
        })
        .catch(err => {
          console.error("Failed to copy text: ", err);
        });
    } else {
      console.error("Clipboard API not available.");
    }
  };

  const [pentaInner, setPentaInner] = useState(penta)
  useEffect(() => {
    if (
      penta.token !== pentaInner.token
      || penta.members.length !== pentaInner.members.length
      || penta.members.name !== pentaInner.members.name
    ) {
      setPentaInner(penta)
    }
  }, [penta])

  

  return (
    <>
      <div className="m_b_c_scroll">

        <div className="m_b_cols">
          <div className="m_b_form0">
            <div className="m_b_form">

              <div className="_fv">

                <div className="x_calc_form_line">
                  <div className="x_calc_form_title">{$ui('penta_name_placeholder')}</div>
                </div>

                <div className="x_calc_form_line">
                  <div className="x_calc_form0">
                    <input
                      disabled={false}
                      ref={inputName}
                      type="text"
                      disabled={penta.my === false}
                      className="x_input x_input--url"
                      onFocus={(e) => e.target.select()}
                      placeholder={$ui('penta_name_placeholder')}
                      onChange={(e) => setName(e.target.value)}
                      defaultValue={pentaInner.name}
                    />
                    {penta.my !== false && <div className="x_input_right">
                      <Button
                        icon="save"
                        disabled={name === pentaInner.name}
                        onClick={() => {
                          context.x.updatePenta({
                            'token': penta.token,
                            'name': name
                          }, (newPenta) => setPentaInner(newPenta))
                        }}
                      />
                    </div>}

                  </div>
                </div>
                {/* {$ui('penta_name_hidden')} */}
              </div>





              <div className="x_info_form_preview_sections">
                <div className="m_b_form">
                  <div className="_fv">
                    <div className="x_calc_form_line">
                      <div className="x_calc_form_title">{$ui('pop_share')}</div>
                    </div>
                    <div className="x_calc_form_line">
                      <div className="x_calc_form0">
                        <input
                          ref={inputRef}
                          disabled={true}
                          type="text"
                          className="x_input x_input--url x_input--disabled"
                          onFocus={(e) => e.target.select()}
                          defaultValue={getPentaUrl()}
                        />
                        <div className="x_input_right">
                          <Button
                            labelMobileOff
                            icon="content_copy"
                            onClick={() => {
                              handleCopy()
                              setCopydone(true)
                              setTimeout(() => {
                                setCopydone(false)
                              }, 1000);
                            }}>
                            <CopyDone copyDone={copydone} />
                            {$ui('pop_button_copy')}
                          </Button>
                        </div>
                      </div>
                    </div>


                    <div className="x_calc_form_line">
                      <div className="x_calc_qr">
                        <QR
                          url={getPentaUrl()}
                        />
                      </div>
                    </div>


                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  )
})



export const CopyDone = ({ copyDone }) => {
  const [copydone, setCopydone] = useState(false);

  useEffect(() => {
    if (copyDone !== copydone) {
      setCopydone(copyDone)
      setTimeout(() => {
        setCopydone(false)
      }, 1000);
    }
  }, [copyDone])


  return (
    <div
      className={copydone ? "x_button_ok inactive active" : "x_button_ok inactive"}
    // style={{ opacity: copydone ? 1 : 0 }}
    >
      <div className="t_icon t_icon--60">check</div>
    </div>
  )
}


